var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-row", [
        _c(
          "div",
          { staticStyle: { padding: "10px 25px" } },
          [
            _c(
              "el-form",
              {
                ref: "form",
                staticStyle: { padding: "10px" },
                attrs: { model: _vm.form, inline: true }
              },
              [
                _c(
                  "el-form-item",
                  [
                    _c("el-input", {
                      attrs: { placeholder: "包裹号", clearable: "" },
                      model: {
                        value: _vm.form.package_no,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "package_no", $$v)
                        },
                        expression: "form.package_no"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c("el-input", {
                      attrs: { placeholder: "货号", clearable: "" },
                      model: {
                        value: _vm.form.goods_no,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "goods_no", $$v)
                        },
                        expression: "form.goods_no"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c("el-input", {
                      attrs: { placeholder: "款号", clearable: "" },
                      model: {
                        value: _vm.form.goods_kh,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "goods_kh", $$v)
                        },
                        expression: "form.goods_kh"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c("el-input", {
                      attrs: { placeholder: "SKU编号", clearable: "" },
                      model: {
                        value: _vm.form.sku,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "sku", $$v)
                        },
                        expression: "form.sku"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "商家核对状态", clearable: "" },
                        model: {
                          value: _vm.form.check_status,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "check_status", $$v)
                          },
                          expression: "form.check_status"
                        }
                      },
                      _vm._l(_vm.SEARCH_OPTIONS.CHECK_STATUS, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { value: item.value, label: item.label }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "有无差异", clearable: "" },
                        model: {
                          value: _vm.form.check_result,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "check_result", $$v)
                          },
                          expression: "form.check_result"
                        }
                      },
                      _vm._l(_vm.SEARCH_OPTIONS.CHECK_RESULT, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { value: item.value, label: item.label }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { "label-width": "0" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.handleSearch }
                      },
                      [_vm._v(" 查询 ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { "label-width": "0" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success" },
                        on: { click: _vm.handleListExport }
                      },
                      [_vm._v("导出列表\n          ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { "label-width": "0" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success" },
                        on: { click: _vm.handleLogExport }
                      },
                      [_vm._v("\n            导出打标日志\n          ")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("el-row", [
        _c(
          "div",
          {
            staticStyle: {
              background: "#f3f3f3",
              height: "50px",
              "line-height": "50px",
              padding: "0 25px",
              display: "flex",
              "align-items": "center"
            }
          },
          [
            _c("div", { staticStyle: { display: "flex" } }, [
              _c("div", { staticStyle: { width: "80px" } }, [
                _vm._v("数据汇总：")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "table-header" }, [
                _c("div", [
                  _vm._v("一手入库：" + _vm._s(_vm.totalData.in_num))
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("商家配货：" + _vm._s(_vm.totalData.num))]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { display: "flex" } },
                  [
                    _vm._v("\n            入库差异："),
                    _c("NumColorCell", {
                      attrs: { num: Number(_vm.totalData.in_feedback_num) || 0 }
                    })
                  ],
                  1
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.tableLoading,
                    expression: "tableLoading"
                  }
                ],
                key: "table1",
                attrs: { data: _vm.listData, border: "", "max-height": "400px" }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "img",
                    label: "商品图片",
                    align: "center",
                    width: "90"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(ref) {
                        var row = ref.row
                        return [
                          _c(
                            "div",
                            {
                              directives: [
                                { name: "viewer", rawName: "v-viewer" }
                              ],
                              staticStyle: {
                                width: "60px",
                                height: "60px",
                                overflow: "hidden",
                                cursor: "pointer"
                              }
                            },
                            [
                              _c("img", {
                                staticStyle: { width: "100%", height: "100%" },
                                attrs: { src: row.main_img }
                              })
                            ]
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "goods_name",
                    label: "商品名称",
                    align: "center",
                    width: "150"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "goods_no",
                    label: "货号",
                    align: "center",
                    width: "100"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "goods_kh",
                    label: "款号",
                    align: "center",
                    width: "130"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "sku",
                    label: "SKU",
                    align: "center",
                    width: "100"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "co_val",
                    label: "颜色",
                    align: "center",
                    width: "100"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "si_val",
                    label: "尺码",
                    align: "center",
                    width: "100"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "package_no",
                    label: "包裹号",
                    align: "center",
                    width: "120"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "check_status_txt",
                    label: "商家核对状态",
                    align: "center",
                    width: "110"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "check_result_txt",
                    label: "核对结果",
                    align: "center",
                    width: "110"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "in_num",
                    label: "一手入库数（当前实时）",
                    align: "center",
                    width: "120"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(ref) {
                        var row = ref.row
                        return [
                          row.in_num
                            ? _c("div", [
                                _c("div", [_vm._v(_vm._s(row.in_num))])
                              ])
                            : _c("div", [_vm._v("0")])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "num",
                    label: "商家配货数",
                    align: "center",
                    width: "120"
                  }
                }),
                _vm._v(" "),
                _c(
                  "el-table-column",
                  {
                    attrs: { prop: "check_goods_num", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _c("NumColorCell", {
                              attrs: { num: row.in_feedback_num || "" }
                            })
                          ]
                        }
                      }
                    ])
                  },
                  [
                    _c(
                      "div",
                      { attrs: { slot: "header" }, slot: "header" },
                      [
                        _c("div", [_vm._v("当前入库差异件数")]),
                        _vm._v(" "),
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content:
                                "入库差异件数 = 一手已入库件数 - 商家配货件数",
                              placement: "top-start"
                            }
                          },
                          [_c("i", { staticClass: "el-icon-question" })]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { align: "center", label: "操作", fixed: "right" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(ref) {
                        var row = ref.row
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function($event) {
                                  return _vm.handleShowLog(row)
                                }
                              }
                            },
                            [_vm._v("查看打标日志")]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm.listData
          ? _c(
              "div",
              { staticStyle: { "text-align": "right", padding: "25px" } },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.curPage,
                    background: "",
                    layout: "sizes,total, prev, pager, next,jumper ",
                    total: _vm.count,
                    "page-sizes": [5, 10, 20, 30, 50, 100]
                  },
                  on: {
                    "update:currentPage": function($event) {
                      _vm.curPage = $event
                    },
                    "update:current-page": function($event) {
                      _vm.curPage = $event
                    },
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange
                  }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2717d4c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2717d4c6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/receiveGoods/StockVarianceProcess/components/InventoryByGoods.vue
// module id = null
// module chunks = 